module.exports = __webpack_public_path__ + "img/app.354f2bae.png";